import ProximaNovaRegular from '../fonts/proximaNova/proximanova-regular.otf'
import ProximaNovaMedium from '../fonts/proximaNova/proximanova-medium.otf'
import ProximaNovaBold from '../fonts/proximaNova/proximanova-bold.otf'

import { black } from '../const/colors'
import {
  DEFAULT_GRAPH_COLOR,
  GRAPH_COLOR_1,
  GRAPH_COLOR_2,
  GRAPH_COLOR_3,
  MENU_BAR,
  MENU_BAR_ACCOUNT_LABEL,
  MENU_BAR_ACCOUNT_NAME,
  MENU_BAR_ICON,
  MENU_BAR_INFO_ACCOUNT_NAME,
  MENU_BAR_INFO_USER_NAME,
  MENU_BAR_LIST_LINK,
  MENU_BAR_LIST_LINK_ACTIVE,
  MENU_BAR_LIST_LINK_CONTENT,
  SELECT_OPTION_FOCUSED_COLOR
} from './getDefaultTheme'

const brandPrimary = '#55F48E'
const brandPrimaryLight = '#A4F8C0'

const menuBarIconColor = '#FFFFFF'
const menuBarTextColor = '#999999'

export const connectImgTheme = {
  brandPrimary,
  brandPrimaryLight,
  brandPrimaryTextContrastColor: black,
  fontFamily: {
    name: 'ProximaNova',
    value: 'ProximaNova, sans-serif',
    normal: ProximaNovaRegular,
    medium: ProximaNovaMedium,
    bold: ProximaNovaBold,
    format: 'opentype'
  },
  [MENU_BAR]: {
    backgroundColor: black
  },
  [MENU_BAR_ACCOUNT_NAME]: {
    color: '#FFFFFF',
    fontSize: 20
  },
  [MENU_BAR_ACCOUNT_LABEL]: {
    color: '#FFFFFF'
  },
  [MENU_BAR_INFO_USER_NAME]: {
    color: '#FFFFFF'
  },
  [MENU_BAR_INFO_ACCOUNT_NAME]: {
    color: '#FFFFFF'
  },
  [MENU_BAR_LIST_LINK]: {
    backgroundColor: 'transparent',
    fontWeight: 'bold',
    fontSize: '20px',
    color: menuBarTextColor
  },
  [MENU_BAR_LIST_LINK_ACTIVE]: {
    color: brandPrimary
  },
  [MENU_BAR_LIST_LINK_CONTENT]: {
    padding: '2px 8px',
    minHeight: '24px'
  },
  [MENU_BAR_ICON]: {
    color: menuBarIconColor
  },

  [DEFAULT_GRAPH_COLOR]: brandPrimary,
  [GRAPH_COLOR_1]: brandPrimary,
  [GRAPH_COLOR_2]: '#C642F5',
  [GRAPH_COLOR_3]: '#FF145A',
  // select colors
  [SELECT_OPTION_FOCUSED_COLOR]: black
}
